var _defineProperty = require("/codebuild/output/src1871403156/src/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _require = require('../../utility'),
    getSessionId = _require.getSessionId,
    getUserId = _require.getUserId; // Valid Motorrad page types


var pageTypes = ["Home", "Showroom", "Model Showroom", "Brochure", "Trade In", "Vehicle Listing", "Vehicle Details", "Test Drive", "Dealer Specials", "OEM Incentives", "Service Specials", "Finance", "Service", "Schedule Service", "Tire Store", "Parts", "Accessories", "Apparel", "About Us", "Hours & Directions", "Contact Us", "Custom Dealer Content", "Page Not Found", "Blog", "Other"]; // Helper function to get the value from a specific DOM element by its id attribute

function getValueById(id) {
  var element = document.querySelector("data[id=\"".concat(id, "\"]"));
  return element ? element.value : "";
}
/**
 * Build remaining data for page view event processing.
 * @param {object} data - Event data to build on.
 * @returns {object} Page view data object or failure message of data processing.
 */


function buildPageViewData(data) {
  try {
    // Get traffic type from URL
    var getTrafficType = function getTrafficType() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);

      if (urlParams.has('gclid')) {
        return 'Paid Search';
      } else {
        return 'Organic Search';
      }
    }; // Determine page type


    var pageType = data.pageType || getValueById("pageType") || 'Other'; // Initialize page view data

    var pageViewData = {
      events: 'pageview',
      pageType: pageType,
      websiteTier: 'Tier 3',
      sessionId: getSessionId(),
      language: 'en',
      trafficType: getTrafficType(),
      siteTechnologyVersion: '2.0',
      userID: getUserId(),
      dealerZipCode: getValueById("postalCode"),
      dealerState: getValueById("state"),
      dealerCity: getValueById("city")
    }; // Build data depending on page type

    switch (pageType) {
      case 'Page Not Found':
        return pageViewData;
        break;

      case 'Vehicle Details':
        return _objectSpread(_objectSpread({}, pageViewData), {}, {
          pageBrand: data.manufacturer,
          dealerName: data.dealerName,
          status: getValueById("status"),
          year: getValueById("year"),
          make: getValueById("make"),
          model: getValueById("model"),
          exteriorColor: getValueById("exteriorColor"),
          vin: getValueById("vin"),
          msrp: getValueById("msrp"),
          displayedPrice: getValueById("displayedPrice")
        });
        break;

      default:
        return _objectSpread(_objectSpread({}, pageViewData), {}, {
          pageBrand: data.manufacturer,
          dealerName: data.dealerName
        });
    }
  } catch (error) {
    throw error;
  }
}
/**
 * Build remaining data for filter search event processing.
 * @param {object} data - Event data to build on.
 * @returns {object} Filter search data object or failure message of data processing.
 */


function buildFilterSearchData(data) {
  try {
    // Get search status from search object
    var getFilterSearchStatus = function getFilterSearchStatus(searchObject) {
      if (searchObject.certified && !searchObject.new) {
        return 'CPO';
      }

      if (searchObject.certified && searchObject.new || searchObject.new === 'true,false') {
        return 'Mixed';
      }

      if (searchObject.new && !searchObject.certified && searchObject.new !== 'true,false') {
        if (searchObject.new === 'true') {
          return 'New';
        }

        if (searchObject.new === 'false') {
          return 'Used';
        }
      }

      return 'Mixed';
    }; // Get search year from search object


    var getFilterSearchYear = function getFilterSearchYear(searchObject) {
      if (searchObject["min-year"] === searchObject["max-year"]) {
        return searchObject["min-year"];
      }

      if (searchObject["min-year"] !== searchObject["max-year"]) {
        return "".concat(searchObject["min-year"], "-").concat(searchObject["max-year"]);
      }
    };

    return {
      countSearchResults: data.countSearchResults,
      filterSearch: {
        status: getFilterSearchStatus(data.searchObject),
        year: getFilterSearchYear(data.searchObject),
        make: data.searchObject.make,
        model: data.searchObject.model,
        color: data.searchObject.exteriorcolor,
        minPrice: data.searchObject["min-cost"],
        maxPrice: data.searchObject["max-cost"],
        category: 'Street bikes'
      },
      events: 'filterSearch'
    };
  } catch (error) {
    throw error;
  }
}
/**
 * Default handler for Motorrad events.
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */


function Motorrad_Handler(data, options) {
  try {
    var postData = _objectSpread({}, data);

    var sdb = window.sdb ? window.sdb : undefined;
    var dealerCode = getValueById("dealerCode"); // Check if SDB and dealerCode are defined

    if (sdb && dealerCode) {
      // Build data depending on event type
      switch (postData.events) {
        case 'pageview':
          postData = buildPageViewData(postData);
          break;

        case 'filterSearch':
          postData = buildFilterSearchData(postData);
          break;
      } // Build default data


      postData = _objectSpread(_objectSpread({}, postData), {}, {
        timestamp: new Date().toISOString()
      }); // Post data to SDB

      sdb('dataLayer', postData);
      sdb('send', postData.events);
      return {
        status: 'success',
        message: 'Motorrad event processed successfully',
        data: postData
      };
    } else {
      if (!sdb) {
        return 'Cannot capture event, SDB is not defined.';
      } else {
        return 'Cannot capture event, dealerCode is not found.';
      }
    }
  } catch (error) {
    return {
      status: 'error',
      message: "Motorrad Handler failed to capture event. Error: ".concat(err.message),
      data: data
    };
  }
} // Manage SDB session


function SDBSession() {
  // Get SDB and dealerCode
  var sdb = window.sdb ? window.sdb : undefined;
  var dealerCode = getValueById("dealerCode"); // Check if SDB and dealerCode are defined

  if (sdb && dealerCode) {
    // Check if SDB session is initialized
    var SDBInit = sessionStorage.getItem('sdbInit'); // Initialize SDB session

    if (!SDBInit) {
      console.log('Initializing SDB...');
      sdb('create', 'BMWMOTORRAD', dealerCode, 'MXS');
      sessionStorage.setItem('sdbInit', true);
    } // Remove SDB session on page unload


    window.addEventListener('beforeunload', function () {
      sessionStorage.removeItem('sdbInit');
    });
  } else {
    console.log('Cannot initialize, SDB is not defined.');
  }
}

module.exports = {
  Motorrad_Handler: Motorrad_Handler,
  SDBSession: SDBSession
};